"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToNearestTimeSlot = void 0;
const date_fns_1 = require("date-fns");
/**
 * @summary Rounds the date to the nearest time-slot.
 *
 * Rounds the given date to the nearest time-slot. Time slots start every 15 minutes.
 *
 * @param {number | Date} date
 * @returns {Date}
 *
 * @example
 * const start = roundToNearestTimeSlot(dateInput);
 */
function roundToNearestTimeSlot(date) {
    return (0, date_fns_1.roundToNearestMinutes)(date, { nearestTo: 15 });
}
exports.roundToNearestTimeSlot = roundToNearestTimeSlot;
